const { EventBus } = require("primevue/utils");

export default EventBus();
